import React from "react"
import { Row, Col } from "antd";
import { Link } from "react-router-dom";
import classes from "./Footer.module.css";
import logo from "../../img/logoFooter.png";
import yp from "../../img/yp.png";
import espa from "../../img/espa.png";
import phone from "../../img/phoneIcon.png"
import fb from "../../img/fbIcon.png"
import mail from "../../img/mailIcon.png"
import twitter from "../../img/twitterIcon.png"


import { useTranslation } from "react-i18next"

const Footer = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className={classes.footer_upper}>
        <ul className={classes.footer_menu1}>
        <li>
            <Link to="/events">{t("Εκδηλώσεις")}</Link> 
          </li>
          <li>
            <Link to="/map">{t("Χάρτης")}</Link> 
          </li>
          <li>
            <Link to="/museums" className='lang'>{t("Μουσεία")}</Link>
          </li>
          <li>
            <Link to="/collection" className='lang'>{t("Εκθέματα")}</Link>
          </li>
        </ul>
        
        <ul className={classes.footer_menu2}>
          <li>
            <Link to="/terms">{t("Όροι και Προϋποθέσεις")}</Link>
          </li>
          <li>
            <Link to="/privacy-policy">{t("Πολιτική Απορρήτου")}</Link>
          </li>
          <li>
            <Link to="/privacy-policy">{t("Προσωπικά Δεδομένα")}</Link>
          </li>
        </ul>
      </div>

      <Row style={{ backgroundColor: "#F9F2E6", padding: '1.5rem' }}>
        <Col xs={24} sm={24} md={24} lg={12} xl={11}>
          <Row>
            <div className={classes.footer_lower_1}>
              <Col xs={12} sm={12} lg={12} xl={12}>
                <Link to="/" className={classes.stylesA}>
                  <img src={logo} className={classes.footerLogo}/>
                </Link>
              </Col>
              <Col xs={10} sm={10} lg={8} xl={8}>
                <Link to="/">
                  <img src={phone} className={classes.footerIcon}/>
                </Link>
                <Link to="/">
                  <img src={fb} className={classes.footerIcon}/>
                </Link>
                <Link to="/">
                  <img src={mail} className={classes.footerIcon}/>
                </Link>
                <Link to="/">
                  <img src={twitter} className={classes.footerIcon}/>
                </Link>
              </Col>
            </div>
          </Row>
        </Col>

        <Col xs={12} sm={12} lg={7} xl={7} style={{display: 'flex'}}>
          <div className={classes.footer_lower_2}>
            <img src={yp} />
          </div>
        </Col>
        <Col xs={12} sm={12} lg={5} xl={5} style={{display: 'flex'}}>
          <div className={classes.footer_lower_2}>
            <img src={espa} />
          </div>
        </Col>
      </Row>
    </>
  );
}

export default Footer;
